import { render } from "./hrm-salary-structure-modal.vue?vue&type=template&id=72e6cdbc"
import script from "./hrm-salary-structure-modal.vue?vue&type=script&lang=js"
export * from "./hrm-salary-structure-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__